(() => {
  const policyLinks = [
    ['/policies/privacy-policy', 'Privacy Policy'],
    ['/policies/refund-policy', 'Refund Policy'],
    ['/policies/shipping-policy', 'Shipping Policy'],
    ['/policies/terms-of-service', 'Terms of Service'],
    ['/pages/cookie-policy', 'Cookie Policy'],
    ['/pages/your-privacy-choices', 'Your Privacy Choices'],
  ];
  // 自建法务页（Shopify 政策槽位里没有的那两个）各自的一句说明；
  // 4 个 Shopify 政策页共用同一句。
  const pageIntros = {
    '/pages/cookie-policy': 'How we use cookies and similar technologies on this site.',
    '/pages/your-privacy-choices': 'The choices you have about the personal information we collect.',
  };

  // Shopify 给的政策标题是小写（Privacy policy / Terms of service），左栏标题统一成 Title Case
  const policyTitles = {
    'Privacy policy': 'Privacy Policy',
    'Refund policy': 'Refund Policy',
    'Shipping policy': 'Shipping Policy',
    'Terms of service': 'Terms of Service',
  };
  const titleCase = (t) => policyTitles[t] || t;

  const path = window.location.pathname;
  const visiblePolicyLinks = policyLinks.slice(0, 4);
  let target = null;

  if (path.startsWith('/policies/')) {
    const container = document.querySelector('.shopify-policy__container');
    if (!container || container.dataset.jcPolicyEnhanced === 'true') return;
    const titleNode = container.querySelector('.shopify-policy__title h1, .shopify-policy__title');
    const bodyNode = container.querySelector('.shopify-policy__body');
    if (!titleNode || !bodyNode) return;
    target = {
      container,
      title: titleCase(titleNode.textContent.trim()),
      content: bodyNode,
      intro: 'Clear information for every order, delivery, and data choice.',
    };
  } else if (pageIntros[path]) {
    const heading = document.querySelector('main h1');
    const content = document.querySelector('main .rte');
    const container = content && content.parentElement;
    if (!heading || !content || !container || container.dataset.jcPolicyEnhanced === 'true') return;
    target = { container, title: heading.textContent.trim(), content, intro: pageIntros[path] };
  }

  if (!target) return;

  const layout = document.createElement('div');
  layout.className = 'jc-native-policy-layout';

  const rail = document.createElement('aside');
  rail.className = 'jc-native-policy-layout__rail';
  rail.innerHTML = `
    <p class="jc-native-policy-layout__eyebrow">Jungle Calling · Customer Care</p>
    <h1 class="jc-native-policy-layout__title">${target.title}</h1>
    <p class="jc-native-policy-layout__intro">${target.intro}</p>
    <nav class="jc-native-policy-layout__nav" aria-label="Policy navigation">
      ${visiblePolicyLinks.map(([href, label]) => `<a href="${href}"${path === href ? ' aria-current="page"' : ''}>${label}</a>`).join('')}
    </nav>
    <a class="jc-native-policy-layout__support" href="mailto:business@jungle-calling.com">Need help? Contact Support</a>
  `;

  const documentPanel = document.createElement('article');
  documentPanel.className = 'jc-native-policy-layout__document';
  documentPanel.appendChild(target.content);

  layout.append(rail, documentPanel);
  target.container.replaceChildren(layout);
  target.container.dataset.jcPolicyEnhanced = 'true';
  document.body.classList.add('jc-policy-route');
})();
